// --------------------------------------------------------------
// Created On: 2024-05-16
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment, useState } from "react";
import Error from "../../../components/Error/Error";
import Modal from "../../../components/Modal/Modal";
import ModalBody from "../../../components/ModalBody/ModalBody";
import ModalFooter from "../../../components/ModalFooter/ModalFooter";
import Spinner from "../../../components/Spinner/Spinner";
import styles from "./SearchModal.module.scss";
import SearchBar from "../../../components/SearchBar/SearchBar";

// Modal for searching for parts or BOMs.
export default function SearchModal(props: Props): Component {
  const [loading, setLoading] = useState<boolean>(false);
  const [startSearch, setStartSearch] = useState<boolean>(false);
  const [searchOption, setSearchOption] = useState<SearchOption>("SERIAL");
  const [errorMessage, setErrorMessage] = useState<string>("");

  return (
    <Fragment>
      <Spinner loading={loading} />
      <Modal
        show={props.showModal}
        onHide={() => props.onClose()}
        backdropClassName={`${styles.modal} ${styles.backdrop}`}
        style={{ zIndex: "var(--standard-modal-z-index)" }}
        size="lg"
        centered
        animation
      >
        <ModalBody>
          <div>
            <h6 className="lead text-center mb-4">
              <strong>Search by BOM, part or serial number.</strong>
            </h6>
            <SearchBar
              isInNavbar={false}
              isInNavDrawer={false}
              isInDashboard={false}
              startSearch={startSearch}
              errorMessage={errorMessage}
              overrideSearchOption={searchOption}
              onOverrideSearchOptionChange={(searchOption) => setSearchOption(searchOption)}
              onSearchComplete={() => setStartSearch(false)}
              onErrorMessageChange={(errorMessage) => setErrorMessage(errorMessage)}
              onLoadingChange={(loading) => setLoading(loading)}
              onClose={() => props.onClose()}
            />
            {errorMessage !== "" && (
              <div className="text-sm-center fw-bold">
                <Error message={errorMessage} />
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setStartSearch(true);
            }}
          >
            Search
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => props.onClose()}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

interface Props {
  showModal: boolean;
  onClose: () => void;
}

type SearchOption = "BOM" | "SERIAL" | "PART";
